import React, { PureComponent } from "react";
import classNames from "../../utils/classnames";

export class Preview extends PureComponent {
  render() {
    const { children, className, ...others } = this.props;
    const cls = classNames({
      "weui-form-preview": true
    }, className);

    return (
      <div className={ cls } { ...others }>
        { children }
      </div>
    );
  }
}
